import { QueryString } from '../functions';

$(document).ready(function() {
    const filters = {
        isLoading: false,
        init() {
            $(document).on('change', '#sort', this, this.sort);
            $(document).on('click', '.mobile-sort', this, this.mobileSort);
            $(document).on('click', '.category-filter', this, this.categories);
            $(document).on('click', '.search-category-filter', this, this.searchCategories);
            $(document).on('click', '.main-category-filter', this, this.mainCategory);
            $(document).on('click', '.brand-filter', this, this.brands);
            $(document).on('click', '.material-filter', this, this.materials);
            $(document).on('click', '.color-filter', this, this.colors);
        },
        sort(event) {
            const _this = event.data;
            let url = $(this).data('url');

            let query = _this.getSelectedFiltersFromUrl(['sort']);
            if ($('#sort option:selected').val() != '') {
                if (query == '') {
                    query += '?sort=' + $('#sort option:selected').val();
                } else {
                    query += '&sort=' + $('#sort option:selected').val();
                }
            }

            window.location = url + query;
        },
        mobileSort(event) {
            const _this = event.data;
            let url = $(this).data('url');

            let query = _this.getSelectedFiltersFromUrl(['sort']);
            if ($('#sort option:selected').val() != '') {
                if (query == '') {
                    query += '?sort=' + $('#sort option:selected').val();
                } else {
                    query += '&sort=' + $('#sort option:selected').val();
                }
            }

            window.location = url + query;
        },
        colors(event) {
            const _this = event.data;
			let url = $(this).data('url');
			let id = $(this).data('id');

			let selectedValues = [];
			if (QueryString(null).cl) {
				selectedValues = QueryString(null).cl.split(',').map(Number);
			}

			let index = selectedValues.indexOf(1*id);
			if (index == -1) {
				selectedValues.push(1*id);
			} else {
				selectedValues.splice(index, 1);
			}

			let query = _this.getSelectedFiltersFromUrl(['cl', 'page']);
			if (selectedValues.length > 0) {
				if (query == '') {
					query += '?cl=' + selectedValues.join(',');
				} else {
					query += '&cl=' + selectedValues.join(',');
				}
			}

			window.location = url + query;
		},
        materials(event) {
            const _this = event.data;
			let url = $(this).data('url');
			let id = $(this).data('id');

			let selectedValues = [];
			if (QueryString(null).m) {
				selectedValues = QueryString(null).m.split(',').map(Number);
			}

			let index = selectedValues.indexOf(1*id);
			if (index == -1) {
				selectedValues.push(1*id);
			} else {
				selectedValues.splice(index, 1);
			}

			let query = _this.getSelectedFiltersFromUrl(['m', 'page']);
			if (selectedValues.length > 0) {
				if (query == '') {
					query += '?m=' + selectedValues.join(',');
				} else {
					query += '&m=' + selectedValues.join(',');
				}
			}

			window.location = url + query;
		},
        brands(event) {
            const _this = event.data;
			let url = $(this).data('url');
			let id = $(this).data('id');

			let selectedValues = [];
			if (QueryString(null).b) {
				selectedValues = QueryString(null).b.split(',').map(Number);
			}

			let index = selectedValues.indexOf(id);
			if (index == -1) {
				selectedValues.push(id);
			} else {
				selectedValues.splice(index, 1);
			}

			let query = _this.getSelectedFiltersFromUrl(['b', 'page']);
			if (selectedValues.length > 0) {
				if (query == '') {
					query += '?b=' + selectedValues.join(',');
				} else {
					query += '&b=' + selectedValues.join(',');
				}
			}

			window.location = url + query;
		},
        mainCategory(event) {
			const _this = event.data;
			let url = $(this).data('url');
			let id = $(this).data('id');
			let subIds = $(this).data('sub-ids');

			let selectedValues = [];
			if (QueryString(null).c) {
				selectedValues = QueryString(null).c.split(',').map(Number);
			}

			let query = _this.getSelectedFiltersFromUrl(['c','exm', 'page']);
            if (QueryString(null).exm) {
				if (subIds != '') {
					var subIdsArr = subIds.split(',');
					for(var i in  subIdsArr) {
						let subIndex = selectedValues.indexOf(1*subIdsArr[i]);
						if (subIndex == -1) {
							selectedValues.push(subIdsArr[i]);
						} else {
							//selectedValues.splice(subIndex, 1);
						}
					}
				}
            } else {
				if (query == '') {
                    query += '?exm=1';
                } else {
                    query += '&exm=1';
                }
				if (subIds != '') {
					var subIdsArr = subIds.split(',');
					for(var i in  subIdsArr) {
						let subIndex = selectedValues.indexOf(1*subIdsArr[i]);
						// console.log(subIdsArr[i]);
						// console.log(subIndex);
						if (subIndex == -1) {
							//selectedValues.push(subIdsArr[i]);
						} else {
							selectedValues.splice(subIndex, 1);
						}
					}
				}
			}

			if (selectedValues.length > 0) {
				if (query == '') {
					query += '?c=' + selectedValues.join(',');
				} else {
					query += '&c=' + selectedValues.join(',');
				}
			}

			window.location = url + query;
		},
        categories(event) {
            const _this = event.data;
			let url = $(this).data('url');
			let parentId = $(this).data('parent-id');
			let id = $(this).data('id');
			let subIds = $(this).data('sub-ids');

			if (1*parentId != 1*mainCategoryId) {
				window.location = url + '?c=' + id;
				return;
			}

			let selectedValues = [];
			if (QueryString(null).c) {
				selectedValues = QueryString(null).c.split(',').map(Number);
			}

			let index = selectedValues.indexOf(1*id);
			if (index == -1) {
				selectedValues.push(id);
				if (subIds != '') {
					var subIdsArr = subIds.split(',');
					for(var i in  subIdsArr) {
						let subIndex = selectedValues.indexOf(1*subIdsArr[i]);
						if (subIndex == -1) {
							selectedValues.push(subIdsArr[i]);
						} else {
							//selectedValues.splice(subIndex, 1);
						}
					}
				}
			} else {
				selectedValues.splice(index, 1);
				if (subIds != '') {
					var subIdsArr = subIds.split(',');
					for(var i in  subIdsArr) {
						let subIndex = selectedValues.indexOf(1*subIdsArr[i]);
						// console.log(subIdsArr[i]);
						// console.log(subIndex);
						if (subIndex == -1) {
							//selectedValues.push(subIdsArr[i]);
						} else {
							selectedValues.splice(subIndex, 1);
						}
					}
				}
			}

			let query = _this.getSelectedFiltersFromUrl(['c', 'page']);
			if (selectedValues.length > 0) {
				if (query == '') {
					query += '?c=' + selectedValues.join(',');
				} else {
					query += '&c=' + selectedValues.join(',');
				}
			}

			window.location = url + query;
		},
        searchCategories(event) {
            const _this = event.data;
			let url = $(this).data('url');
			let parentId = $(this).data('parent-id');
			let id = $(this).data('id');
			let subIds = $(this).data('sub-ids');

			let selectedValues = [];
			if (QueryString(null).c) {
				selectedValues = QueryString(null).c.split(',').map(Number);
			}

			let index = selectedValues.indexOf(1*id);
			if (index == -1) {
				selectedValues.push(id);
				if (subIds != '') {
					var subIdsArr = subIds.split(',');
					for(var i in  subIdsArr) {
						let subIndex = selectedValues.indexOf(1*subIdsArr[i]);
						if (subIndex == -1) {
							selectedValues.push(subIdsArr[i]);
						} else {
							//selectedValues.splice(subIndex, 1);
						}
					}
				}
			} else {
				selectedValues.splice(index, 1);
				if (subIds != '') {
					var subIdsArr = subIds.split(',');
					for(var i in  subIdsArr) {
						let subIndex = selectedValues.indexOf(1*subIdsArr[i]);
						// console.log(subIdsArr[i]);
						// console.log(subIndex);
						if (subIndex == -1) {
							//selectedValues.push(subIdsArr[i]);
						} else {
							selectedValues.splice(subIndex, 1);
						}
					}
				}
			}

			let query = _this.getSelectedFiltersFromUrl(['c', 'page']);
			if (selectedValues.length > 0) {
				if (query == '') {
					query += '?c=' + selectedValues.join(',');
				} else {
					query += '&c=' + selectedValues.join(',');
				}
			}

			window.location = url + query;
		},
		getSelectedFiltersFromUrl(exclude = []) {
			var query = '';

			var data = QueryString(null);
			for (var key of Object.keys(data)) {
				if (key != '') {
					if (exclude.indexOf(key) == -1) {
						if (query != '') {
							query += '&' + key + '=' + data[key];
						} else {
							query += '?' + key + '=' + data[key];
						}
					}
				}
			}

	    	return query;
		}
    };

    if ($('.filters-container').length) {
        filters.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/filters.js